import { defineComponent } from "vue";

// The parent table reads this declaration's VNode and renders its slots.
export const Column = defineComponent({
  name: "LISADataTableColumnDeclaration",
  inheritAttrs: false,
  setup: () => () => null,
});
